
import { API_BASE_URL } from '@/config/api';

export async function uploadFileToStrapi(fileBlob: Blob, fileName: string): Promise<number | null> {
  try {
    const formData = new FormData();
    formData.append("files", fileBlob, fileName);
    const jwt = localStorage.getItem('token');

    console.log('📤 Uploading file to Strapi:', fileName);

    const response = await fetch(`${API_BASE_URL}/upload`, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    });

    if (!response.ok) {
      console.error('❌ Upload failed with status:', response.status);
      throw new Error("Error al subir el archivo a Strapi.");
    }

    const result = await response.json();
    console.log('✅ File uploaded successfully:', result);
    return result[0]?.id; // ID del archivo subido
  } catch (error) {
    console.error("❌ Error al subir archivo a Strapi:", error);
    return null;
  }
}
